import * as React from "react";
import PropTypes from 'prop-types';

const SvgTick = props => {
  if (props.id !== "_svgtick") {
    throw new Error('SVG requires <Icon> component as a parent, e.g. <Icon><SvgLogo></Icon>');
  }

  return <svg viewBox="0 0 14 10" fill="none" {...props}><path d="M13.4 2.093L11.471.2l-5.92 5.812L2.53 3.044.6 4.938l4.951 4.861 7.85-7.706z" fill="#fff" /></svg>;
};

SvgTick.displayName = "_svgtick";
SvgTick.propTypes = {
  id: PropTypes.string
};
SvgTick.defaultProps = {
  id: ''
};
export default SvgTick;